<template>
    <div
        :class="{
            'video-wrap': true,
            'right': isOwn
        }"
    >
        <template v-if="msgInfo.type!=='lock'">
          <video class="video" controls @loadeddata="handleLoadedData">
            <source :src="url" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </template>
        <div class="lock" @click="handleUnlock(msgInfo)" v-else></div>
    </div>
</template>

<script>
export default {
  props: {
    msgInfo: {
      type: Object,
      default: () => ({}),
    },
    isOwn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    url() {
      return this.msgInfo?.content?.video_url ?? '';
    },
  },
  methods: {
    handleUnlock(item) {
      this.$emit('unlock', item);
    },
    handleLoadedData() {
      this.$emit('loaded');
    },
  },
};
</script>

<style lang="less">
.video-wrap {
    display: flex;
    &.right {
        justify-content: flex-end;
    }
    .video {
        vertical-align: middle;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        max-width: 225px;
        max-height: 300px;
    }
    .lock {
        background: url('@/assets/images/icon/lock.png') rgb(95,93,100,0.6) center no-repeat;
        background-size: 26px 26px;
        width: 115px;
        height: 160px;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        backdrop-filter: blur(6px);
    }
}
</style>
